<template>
  <button type="button" class="btn btn-outline-primary" @click="excelExport" :disabled="isExporting">
    <fa v-if="isExporting" icon="circle-notch" spin />
    <fa v-if="!isExporting" icon="file-excel" />
    <span class="ml-2">Excel Export</span>
  </button>
</template>

<script>
export default {
  props: {
    organizationId: String,
    reportId: String,
  },
  data() {
    return {
      isExporting: false,
    };
  },
  methods: {
    excelExport() {
      this.isExporting = true;
      this.$axios
        .post(`/v1/organizations/${this.organizationId}/reports/${this.reportId}/export/excel`)
        .then(res => {
          const link = document.createElement("a");
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.href = res.data.url;
          link.click();
          link.remove();
        })
        .finally(() => (this.isExporting = false));
    },
  },
};
</script>
